/*eslint-disable*/
import $urls from '../urls/url';
import $api from '../axios/index';
import $Cookies from 'js-cookie';
import {store} from '@/common/index';
import common from './common'

// 登陆前接口
const HOMEBEFORE ={
  // 初始化链接
  initLink(params = {}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.init, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  // 首页优惠导航
  queryIndexOfferList() {
    let params={}
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.queryIndexOfferList, params, (resp) => {
        if(resp.data.success){
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg);
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  // 根据Code获取配置图片
  fetchImgs(imgCode) {
    let params = {
      imgCodes:imgCode
    }
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.fetchImgs, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp.data.data)
        }else {
          resolve([]);
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  fetchImg(imgCode) {
    let params = {
      imgCode:imgCode
    }
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.fetchImg, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp.data.data)
        }else {
          resolve([]);
        }
      }, err => {
        reject(err.message);
      })
    })
  },

  // 老虎机图片地址
  serverInfo() {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.serverInfo, {}, (resp) => {
        if(resp.data.code===200){
          let serverInfo = resp.data.data.serverInfo;
          let picLink = serverInfo.ftpDomain;

          store.dispatch('setSlotPic',picLink);
          resolve(picLink)
        }else {
          reject(resp.data.msg);
        }
      }, err => {
        reject(err.message);
      })
    })
  },

  // 客服链接
  service() {
    return new Promise((resolve, reject) => {
      let params = {
        appVersion: 1.0,
        appType: 'pc'
      }
      $api.post($urls.HOMEBEFORE.service, params, (resp) => {
        if(resp.data.code===110||resp.data.code===111||resp.data.code===200){
          let customerUrl = resp.data.data.customerUrl;
          resolve(customerUrl)
        }else {
          reject(resp.data.msg);
        }
      }, err => {
        reject(err.message);
      })
    })
  },

  // 游戏平台
  // 游戏类型:1 - 老虎机，2-真人，3-体育，4-彩票，5-捕鱼王，6-棋牌，7-3D厅
  gamePlatform(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.gamePlatform, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data;
          resolve(gameForm)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 热门
  heatGamePlatform(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.heatGamePlatform, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data;
          resolve(gameForm)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  queryAllGameList(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.queryAllGameList, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data;
          resolve(gameForm)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  allGameInfo() {
    // gameType:1 - 老虎机，2-真人，3-体育，4-彩票，5-捕鱼王，6-棋牌，7-3D厅
    return new Promise((resolve, reject) => {
      let params = {};
      $api.post($urls.HOMEBEFORE.allGameInfo, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data.length>0) {
            resolve(data)
          }
        }else {
          resolve([])
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 游戏平台图片
  platformPicInfo(params = {}) {
    // let params = {
    //   frontType: 2,
    //   gameType : -1,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.platformPicInfo, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else if(resp.data.code === 201){
          resolve([])
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message);})
    })
  },

  // 获取最热游戏列表
  getGameList() {
    return new Promise((resolve, reject) => {
      let pageNo  = 1;
      let pageSize = 36;
      let params = {
        frontType: store.state.frontType,
        pageNo : pageNo ,
        pageSize: pageSize,
      };
      $api.post($urls.HOMEBEFORE.GAMELIST,params,resp=>{
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          resolve(data)
        } else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },
  // 获取最热游戏列表
  getGameListByNum(num) { // num个数
    return new Promise((resolve, reject) => {
      let pageNo  = 1;
      let pageSize = num;
      let params = {
        frontType: store.state.frontType,
        pageNo : pageNo ,
        pageSize: pageSize,
      };
      $api.post($urls.HOMEBEFORE.GAMELIST,params,resp=>{
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          resolve(data)
        } else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },
  // 游戏页面banner
  getBannerList(id) {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
        position: id,
      };
      $api.post($urls.HOMEBEFORE.BANNERLIST,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data.list;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })

  },
  // 一级导航
  getFirstNav() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType
      };
      $api.post($urls.HOMEBEFORE.FIRSTNAVLIST,params,resp=>{
        if(resp.data.code === 200){
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err.message)})
    });
  },
  // 首页导航
  getFirstNavList() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType
      };
      $api.post($urls.HOMEBEFORE.FIRSTNAVLIST,params,resp=>{
        if(resp.data.code === 200){
          let data = resp.data.data;
          if(data.length>0){
            data.forEach((item,index,arr) => {
              arr[index]['url'] = common.sortIndexNav(item.type);
            })
          }
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    });
  },
  // 获取公告
  pushInfoList() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: 2,
      };
      $api.post($urls.HOMEBEFORE.PUSHINFOLIST,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data.list;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 挂件图片
  floatPicList() {
    return new Promise((resolve, reject) => {
      let params = {};
      $api.post($urls.HOMEBEFORE.floatPicList,params,resp=>{
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  //公益视频
  getGoodVideo(){
    return new Promise((resolve, reject) => {
      let params = {};
      $api.get($urls.HOMEBEFORE.getGoodVideo,params,resp=>{
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  //VIP数据
  getVipInfoLis(){
    return new Promise((resolve, reject) => {
      let params = {};
      $api.get($urls.HOMEBEFORE.getVipInfoLis,params,resp=>{
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
     // 获取365体育信息
  getCustomizeMatch(code){
    return new Promise((resolve, reject) => {
      let params = {
        imgCode: code,
      };
      $api.post($urls.HOMEBEFORE.getCustomizeMatch,params,resp=>{
        if(resp.data.code===200){
          // let data = resp.data.data.list;
          resolve(resp.data.data)
        }else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },
  // 印度获取365体育信息
  getMatchByPlatformCode(){
  return new Promise((resolve, reject) => {
    let params = {
      // imgCode: code,
    };
    $api.post($urls.HOMEBEFORE.getMatchByPlatformCode,params,resp=>{
      if(resp.data.code===200){
        // let data = resp.data.data.list;
        resolve(resp.data.data)
      }else {
        resolve([])
      }
    },err=>{reject(err)})
  })
},

  getRegisterList(){
    return new Promise((resolve, reject) => {
      let params = {
      };
      $api.post($urls.HOMEBEFORE.getRegisterList,params,resp=>{
        if(resp.data.code===200){
          // let data = resp.data.data.list;
          resolve(resp.data.data)
        }else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },


};
// 登陆后接口
const HOMEAFTER ={
  // 登录信息
  logedUserInfo() {
    let browser = common.getBrowserInfo()[0];
    let UUID = $Cookies.get('UUID');
    let deviceId = $Cookies.get('deviceId');
    if(deviceId===undefined||deviceId===''){
      let timeStr = new Date().getTime().toString();
      let str = Math.random().toString().slice(-6);
      deviceId = timeStr + str;
      $Cookies.set('deviceId', deviceId, { expires: 2000 });
    }

    let params = {
      UUID: UUID,
      browser:  browser,
      deviceId: deviceId,
      // domain: document.domain,
      // ipInfo: ' ',
    };

    $api.post($urls.HOMEAFTER.logedUserInfo, params, (resp) => {
      if (resp.data.code === 200) {
        common.deviceInfo();
      } else {}
    }, err => {})

  },
  // 设备信息
  deviceInfo() {
    let UUID = $Cookies.get('UUID');
    let deviceId = $Cookies.get('deviceId');

    let info = common.getOsInfo();
    let os = '',osVersion = '';
    info.name&&(os=info.name);
    info.version&&(osVersion=info.version);

    let params = {
      frontType: store.state.frontType,
      UUID: UUID,
      deviceId: deviceId,
      ip: '',
      clientTime: new Date().getTime(),
      isp: '',
      os: os,
      osVersion: osVersion,
      dns: '',
      dnsLocation: '',
      proxy: '',
      country: '',
      province: '',
      city: '',
      zipCode: '',
      timeZone: '',
      cookieEnable: '',
      jsEnable: '',
      flashEnable: '',
      javaEnable: '',
      activexEnable: '',
      webrtcEnable: '',
      vbEnable: '',
      adblockEnable: '',
      latitude: '',
      longitude: '',
      language: navigator.language,
      deviceMemory: '',
      maxTouchPoints: '',
      hardwareConcurrency: '',
      cpu: '',
      colorDepth: '',
      displayWidth: '',
      displayHeight: '',
    };
    $api.post($urls.HOMEAFTER.DEVIVEINFO, params, (resp) => {
      if (resp.data.code === 200) {
      } else {}
    }, err => {})
  },
  // 最低取款额
  getminLimit(params){
    let UUID = $Cookies.get('UUID');
    params = {
      UUID: UUID,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.getminLimit, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          let result = {
            lockList: [],
            lockInfo: {
              pageNum: 0,
              infoPageSize: 0,
              total: 0,
            }
          }
        }
      }, err => {reject(err)})
    })
  },
  // 365代理联系方式
getfrontconfig(params){
  // let UUID = $Cookies.get('UUID');
  params = {
    configKey: params.configKey,
  };
  return new Promise((resolve, reject) => {
    $api.post($urls.HOMEAFTER.getfrontconfig, params, resp => {
      if (resp.data.code === 200) {
        let data = resp.data.data
        resolve(data)
      } else {
        let msg = resp.data.msg ? resp.data.msg :resp.data.message;
        let result = {
          lockList: [],
          lockInfo: {
            pageNum: 0,
            infoPageSize: 0,
            total: 0,
          }
        }
      }
    }, err => {reject(err)})
  })
},
  // 365代理所有联系方式
  getFrontConfigList(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.getFrontConfigList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          resolve(msg)
        }
      }, err => {reject(err)})
    })
  },
    // USDT汇率
    getusdtRate(params) {
      let UUID = $Cookies.get('UUID');
      params = {
          UUID: UUID,
      };
      return new Promise((resolve, reject) => {
          $api.post($urls.HOMEAFTER.getusdtRate, params, resp => {
              if (resp.data.code === 200) {
                  let data = resp.data.data
                  resolve(data)
              } else {
                  let msg = resp.data.msg ? resp.data.msg : resp.data.message;
                  reject(msg)
              }
          }, err => { reject(err) })
      })
  }, 
  // 刷新登录状态
  refreshUserInfo() {
    let params = {
      UUID: store.state.UUID,
    };
    $api.post($urls.HOMEAFTER.refresh,params,resp=>{},err=>{})
  },
  // 查询会员账户锁定金额记录
  queryUserLockAmount(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.queryUserLockAmount, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let result = {
            lockList: gameList,
            lockInfo: gameInfo,
          };
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          let result = {
            lockList: [],
            lockInfo: {
              pageNum: 0,
              infoPageSize: 0,
              total: 0,
            }
          }
          resolve(result)
        }
      }, err => {reject(err)})
    })
  },
  // 会员自助解锁锁定金额
  selfUnlockAmount(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.selfUnlockAmount, params, resp => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 判断是否代理注册
  queryAgentBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.queryAgentBonus, params, resp => {
        if(resp.data.success) {
          resolve(resp.data.data)
        }else {
          reject()
        }
      }, err => {reject()})
    })
  }
};

const USER ={
  // 登出
  loginOut() {
    store.dispatch('checkLogin');
    let UUID = $Cookies.get('UUID');
    if(UUID){
      return new Promise((resolve, reject) => {
        $api.post($urls.USER.LOGINOUT, {UUID:UUID}, (resp) => {
          if(resp.data.code===200){
            $Cookies.remove('UUID');
            store.dispatch('checkLogin');
            resolve('退出成功')
          }else {
            reject(resp.data.msg);
          }
        }, err => {
          reject(err.message);
        })
      })
    }
  },
  // 第三方登录
  thirAuthLogin(params) {
    // store.dispatch('checkLogin');
    // let UUID = $Cookies.get('UUID');
    // if(UUID){
      return new Promise((resolve, reject) => {
        $api.post($urls.USER.THIRAUTHLOGIN, params, (resp) => {
          if(resp.data.code===200){
            // $Cookies.remove('UUID');
            // store.dispatch('checkLogin');
            // resolve('退出成功')
            resolve(resp.data.data)
          }else {
            reject(resp.data.msg);
          }
        }, err => {
          reject(err.message);
        })
      })
    // }
  },
  // 用户信息
  getUserInfo() {
    return new Promise((resolve, reject) => {
      let browser = common.getBrowserInfo()[0];//取到完整信息
      let UUID = $Cookies.get('UUID');
      let deviceId = $Cookies.get('deviceId');
      if(deviceId===undefined||deviceId===''){
        let timeStr = new Date().getTime().toString();
        let str = Math.random().toString().slice(-6);
        deviceId = timeStr + str;
        $Cookies.set('deviceId', deviceId, { expires: 2000 });
      }
      let params = {
        UUID: UUID,
        browser:  browser,
        deviceId: deviceId,
        domain: document.domain,
        ipInfo: '',
      };

      $api.post($urls.USER.FIRSTUSERINFO, params, (resp) => {
        if (resp.data.code === 200) {
          let userInfo = resp.data.data;
          resolve(userInfo)
        } else if(resp.data.code === 998){
          reject(998)
        } else {
          resp.data.msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })

    })
  },
  // 忘记密码-发送验证码
  sendPhoneCode(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.sendCode, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else{
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  // 忘记密码-重置密码
  confirm(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.confirm, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else{
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  // 注册
  register(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.REGISTER, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data)
        }else{
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  /**
   * 手机验证码登录
   */
  sendVerifictionCode(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.sendVerifictionCode, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else{
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  }
};

const SLOT ={
  // 我的收藏
  getMyslot() {
    return new Promise((resolve, reject) => {
      let datas = [];
      let params = {
        frontType: store.state.frontType,
        UUID: store.state.UUID,
        pageNo: -1,
        pageSize: 0,
      };
      $api.post($urls.SLOT.mySlot, params, resp => {
          if ( resp.data.code === 200) {
            let datas ;
            if( resp.data.data === null || resp.data.data === undefined){
              datas = []
            }else {
              datas = resp.data.data.list
            }
            store.commit('SET_SLOT_COLLECTION',datas);
            resolve(datas)
          }else{
            store.commit('SET_SLOT_COLLECTION',datas);
            resolve(datas)
          }
        }, err => {reject(err.message)})
    });
  },
  // 我的收藏分页
  /**
   * frontType:，UUID:，pageNo:，pageSize: */
  getMyslotStep(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.mySlot, params, resp => {
        if ( resp.data.code === 200) {
          let info = resp.data.data;
          let mySlot = common.slotJoint(store.state.picLink,info.list);
          let data = {
            list: mySlot,
            gameInfo: info
          };

          resolve(data)
        }else{
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    });
  },
  // 新收藏
  getMyNewslot(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.mySlot, params, resp => {
        if ( resp.data.code === 200) {
          // let info = resp.data.data;
          // let mySlot = common.slotJoint(store.state.picLink,info.list);
          // let data = {
          //   list: mySlot,
          //   gameInfo: info
          // };
          resolve( resp.data.data)
        }else{
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    });
  },
  // 根据平台code 获取游戏
  getSlotGameByPlatform(params) {
    // let params = {
    //   platformCode: platformCode,
    //   frontType: this.frontType,
    //   pageNo: this.pageNo,
    //   pageSize: this.pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.GETSLOTGAMEPLATFORM, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 压码排行
  getSlotRank(pageSize) {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
        pageNo: 1,
        pageSize: pageSize,
      };
      $api.post($urls.SLOT.slotRank, params, resp => {
        if (resp.data.code === 200) {
          let data= common.joint(store.state.picLink, resp.data.data.list, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 获取最热游戏列表
  hotGameList(params) {
    return new Promise((resolve, reject) => {
      // let params = {
      //   frontType: store.state.frontType,
      //   pageNo: 1,
      //   pageSize: pageSize,
      // };
      $api.post($urls.HOMEBEFORE.GAMELIST, params, resp => {
        if (resp.data.code === 200) {
          let data= common.joint(store.state.picLink, resp.data.data.list, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 可能喜欢
  getMaybeLike() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
        UUID: store.state.UUID,
        pageNo: 1,
        pageSize: 4,
      };
      $api.post($urls.SLOT.maybeLike, params, resp => {
        if (resp.data.code === 200) {
          let data = common.oldJoint(store.state.picLink, resp.data.data, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },

  // 全部老虎机
  getTotalSlot(pageNo, pageSize) {
    let params = {
      frontType: store.state.frontType,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.totalSlot, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },

  // 老虎机游戏搜索
  selectGameSlotType(params) {
    // 老虎机筛选全选参数不用传,例如5-10线,传min=5,max=10,10线以下传min=10,50线以上传max=50," +
    // "type,1=奖池游戏,2=经典游戏,3=消消乐,4=电动角子，" +
    // "hotOrNew，0=最新游戏，5=热门游戏," +
    // "platformCode,平台编号
    // let params = {
    //   platformCode: '',
    //   min: '',
    //   max: '',
    //   type: '',
    //   hotOrNew: '',
    //   pageNo: '',
    //   pageSize: ''
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.selectGameSlotType, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },

  // 老虎机全部游戏
  selectAllGameSlotType(pageNo, pageSize) {
    let params = {
      platformCode: '',
      min: '',
      max: '',
      type: '',
      hotOrNew: '',
      frontType: store.state.frontType,
      pageNo: pageNo,
      pageSize: pageSize
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.selectGameSlotType, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data
          }
          resolve(result)
        } else {
          let result = {
            gameList: []
          }
          resolve(result)
        }
      }, err => {reject(err)})
    })
  },

  // 收藏
  addCollection(params) {
    // let params = {
    //   slotId: id,
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.addCollection, params, resp => {
        if (resp.data.code === 200) {
          resolve(true)
        }else {
          reject('请稍后再试')
        }
      }, err => {reject(err.message)});
    })
  },
  // 取消收藏
  cancelCollect(params) {
    // let params = {
    //   slotId: id,
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.cancelCollection, params, resp => {
        if (resp.data.code === 200) {
          resolve(true)
        }else {
          reject('请稍后再试')
        }
      }, err => {reject(err.message)});
    })
  },

  // 收藏(有收藏字段)
  getSlot(params) {
    // let params = {
    //   frontType: store.state.frontType,
    //   UUID: store.state.UUID,
    //   pageNo: -1,
    //   pageSize: 0,
    // };
    params['frontType']=store.state.frontType;

    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.mySlot, params, resp => {
        if ( resp.data.code === 200) {

          if(resp.data.data) {
            let gameList = resp.data.data.list;
            gameList = common.joint(store.state.picLink, gameList, store.state.mySlot);
            let gameInfo = resp.data.data;
            let result = {
              gameList: gameList,
              gameInfo: gameInfo,
            };
            resolve(result)
          }else{
            let result = {
              gameList: []
            };
            resolve(result)
          }

        }


      }, err => {reject(err.message)})
    })
  },

};

const WALLET ={
  // 账户刷新
  refresh() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.WALLET.refreshGameAccount,params,(resp)=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 提现申请
  withdrawList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.WALLET.withdrawList, params, (resp) => {
        let data = resp.data.data;
        if(resp.data.code===200){
          resolve(data)
        }else if(resp.data.code!==200){
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    });
  },
  // 投注记录
  gameHistory(params) {
    return new Promise((resolve, reject) => {
        $api.post($urls.WALLET.gameHistory, params, (resp) => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg :resp.data.message;
            reject(msg)
          }
        }, err => {reject(err);})
    });
  },
  // 新投注记录
  newgameHistory(params) {
    return new Promise((resolve, reject) => {
        $api.post($urls.WALLET.newgameHistory, params, (resp) => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            this.loading =  false;
            let msg = resp.data.msg ? resp.data.msg :resp.data.message;
            reject(msg)
          }
        }, err => {reject(err);})
    });
  }
};

const VIP ={
  // 获取账单信息
  myBalanceList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.myBalanceList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取账单信息
  myOrderList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.myOrderList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 账单详情
  getBalanceDetail(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.balanceDetail, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })

    })
  },
  // 站内信
  getMsgSiteList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.getMsgSiteList,params,resp=>{
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })
  },
  // 阅读站内信
  updateMsgSite(id) {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
        msgId: id,
      };
      $api.post($urls.VIP.updateMsgSite,params,resp=>{
        if (resp.data.code === 200) {
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
   // 删除站内信
   deleteMsgSite(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.deleteMsgSite,params,resp=>{
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })
  },
  // 发送站内信
  insertMsgSite(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.insertMsgSite,params,resp=>{
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })
  },
  // 邀请列表
  inviteList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.inviteList,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err);})

    })
  },
  // 领取邀请红利
  getInviteBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.getInviteBonus, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // VIP等级优惠领取
  getVipReward(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.getVipReward, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // 邀请码
  inviteCode() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.VIP.inviteCode,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err);})

    })
  }
};
const SIGN = {
  //信息初始化接口
  //签到可以获得奖励列表 参数pageNo,pageSize
  checkIntegralConfigList(params){
    return new Promise((resolve, reject) =>{
      $api.post($urls.SIGN.checkIntegralConfigList, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})
    })
  },
  //兑换可以获得奖励列表
  bonusExchangeConfigList(params){
    return new Promise((resolve, reject) =>{
      $api.post($urls.SIGN.bonusExchangeConfigList, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})
    })
  },
  getUserIntegral(params){
    return new Promise((resolve, reject) =>{
      $api.post($urls.SIGN.getUserIntegral, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})
    })
  },
  getUserCheckInfo(){
    let params = {}
    return new Promise((resolve, reject) =>{
      $api.post($urls.SIGN.getUserCheckInfo, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})
    })
  },
}
const PAY ={
  // 获取印度银行卡列表
  autoBanks(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.autoBanks, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  //获取会员是否可见预约取款通道
  reserveWithdrawConfig(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.reserveWithdrawConfig, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取印度银行卡列表
  inBanks(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.inBanks, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 印度提交提款订单
  inPayOrder(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.inPayOrder, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 印度USDT存款
  inPayUSDTOrder(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.inPayUSDTOrder, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 印度提交提款订单
  offlineAutopayOrder(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.offlineAuto, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 半自动印度提交提款订单
  semiAutomaticPayOrder(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.semiAutomatic, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  //上传图片
  uploadFile(file) {
    return new Promise((resolve, reject) => {
      console.log(file)
      let params = {
        UUID: store.state.UUID,
        file,
      };
      $api.post($urls.PAY.uploadFile, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取银行卡列表
  bankCardList() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.PAY.bankCardList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          resolve([])
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取银行卡列表
  getindepositOrderlist(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.indepositOrderlist, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          resolve([])
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取银行卡列表
  incancelOrder(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.incancelOrder, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 添加银行卡
  addBank(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.addBankCard,params,resp=>{
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err.message)})
    })
  },
  // 验证银行卡信息
  checkBankCard(item) {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
        cardNumber: item.bankNumber
      };
      $api.post($urls.PAY.checkBankCard, params, resp => {
        if (resp.data.code === 200) {
          item['picUrl'] = resp.data.data.picUrl;
          resolve(item)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})

    })
  },
  // 提款申请
  applyWithdraw(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.applyWithdraw, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})

    })
  },
  // 支付类型
  getPayType(UUID){
     return new Promise((resolve, reject) => {
       let params = {
        deviceType:'pc',
        UUID: store.state.UUID
       };
       $api.post($urls.PAY.payType,params,resp=>{
         if(resp.data.code===200){
           let data =resp.data.data;
           resolve(data)
         }else {
           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
           reject(msg)
         }
       },err=>{reject(err)})
     })
  },
   // 新支付类型
   getNewPayType(UUID){
    return new Promise((resolve, reject) => {
      let params = {
        UUID: UUID,
        deviceType:'pc'
      };
      $api.post($urls.PAY.newPayType,params,resp=>{
        if(resp.data.code===200){
          let data =resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 获取支付的内容
  getPayConfig(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.payConfig, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        }else if(resp.data.code == 202){
          resolve(resp.data.code)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})

    })
  },
  // 获取所有平台
  getAllPlatform() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.PAY.getAllPlatform, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 取出全部的金额，用于提现等页面
  withdrawGames() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.PAY.withdrawGames, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
};

const HELP ={
  // 文章类型
  getArticleType(params={}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HELP.articleType,params, resp=>{
        if(resp.data.code===200) {
          let navList = resp.data.data;
          resolve(navList)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },

  // 根据类型获取文章
  getArticleListByType(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HELP.articleListByType, params, resp => {
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data);
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err.message)})
    });
  },
  // 根据文章ID获取文章内容
  articleById(id) {
    return new Promise((resolve, reject) => {
      let params = {
        articleId: id,
      }
      $api.post($urls.HELP.articleById,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data);
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err.message)})
    })
  }
};

const CONFIRM ={
  // 绑定生日
  submitBirthDay(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.submitBirthDay,params,resp=>{
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 实名认证
  confirmRealName(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmRealName,params,resp=>{
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 提款密码验证码
  sendWithdrawYZM() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      }
      $api.post($urls.PAY.sendWithdrawYZM,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 设置提款密码
  setWithdrawPW(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.setWithdrawPW,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 修改提款密码
  updateWithdrawPW(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.updateWithdrawPW,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 修改登录密码
  updateLoginPassword(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.updateLoginPassword,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)});
    })
  },
  // 修改手机号验证码
  sendPhone(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.sendPhone,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
    // 印度彩票注册页面发送验证码
    sendVerify(params) {
      return new Promise((resolve, reject) => {
        $api.post($urls.CONFIRM.sendVerify,params,resp=>{
          if(resp.data.code===200){
            resolve('success')
          }else {
            let msg = resp.data.msg ? resp.data.msg :resp.data.message;
            reject(msg)
          }
        },err=>{reject(err)})
      })
    },
  // 手机号认证
  confirmPhone(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmPhone,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)});
    })
  },
  // 邮箱发送邮件
  email(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.email,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)});
    })
  },
  // 邮箱认证
  confirmEmail(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmEmail,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 邮箱 认证 只需要邮箱
  submitEmail(params) {
    // params={
    //   UUID,
    //   email
    // }
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.submitEmail,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err.message)})
    })
  },
  // 获取电话验证国家列表
  queryCountryList(params={}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.queryCountryList,params,resp=>{
        if(resp.data.success){
          resolve(resp.data.data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },

  //
// QQ认证
  confirmQQ(params={}) {
    // let params = {
    //   UUID,
    //   qq
    // }
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmQQ,params,resp=>{
        if(resp.data.code===200){
          resolve(resp.data.data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 微信认证
  confirmWeChat(params={}) {
    // let params = {
    //   UUID,
    //   weChat
    // }
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmWeChat,params,resp=>{
        if(resp.data.code===200){
          resolve(resp.data.data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
};

const GAME ={
  // 获取今日流水
  topFlowData(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.topFlowData, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 老虎机搜索
  searchResult(name) {
    return new Promise((resolve, reject) => {
      let params = {
        keyword: name,
      };
      $api.post($urls.GAME.searchResult, params, (resp) => {
        if (resp.data.code === 200) {
          let data = common.joint(store.state.picLink, resp.data.data, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  // 平台全部游戏
  allGame(platformCode,gameType,keyword,pageNo,pageSize) {
    let params = {
      platformCode,
      gameType,
      keyword,
      pageNo,
      pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.allGame, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          resolve({
            gameList: [],
            gameInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            },
          })
        }
      }, err => {reject(err)})
    })
  },
  // 平台热门游戏
  hotGame(platformCode,gameType,pageNo,pageSize) {
    let params = {
      platformCode,
      gameType,
      pageNo,
      pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.hotGame, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          resolve({
            gameList: [],
            gameInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            },
          })
        }
      }, err => {reject(err)})
    })
  },
// 平台最新游戏
  newGame(platformCode,gameType,pageNo,pageSize) {
    let params = {
      platformCode,
      gameType,
      pageNo,
      pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.newGame, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          resolve({
            gameList: [],
            gameInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            },
          })
        }
      }, err => {reject(err)})
    })
  },

   // 新增热门游戏
  newHeatGamePlatform(){
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.newHeatGamePlatform, {}, resp => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        }else{
          resolve(resp.data.msg)
        }
      }, err => {
        reject(err)
      })
    })
  }
};

const DISCOUNTS = {
  // 获取优惠列表
  // let params = {
  //   offerTypes: -1 ,
  //   frontType:this.frontType,
  //   pageNo: this.pageNo,
  //   pageSize: this.pageSize,
  // };
  offerList( params = {} ) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.OFFERLIST, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})
    })
  },
  //获取排行榜数据
  getrankList( params ) {
    return new Promise((resolve, reject) => {
      $api.get($urls.DISCOUNTS.getrankList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          reject(resp)
        }
      },err=>{reject(err)})
    })
  },
  // 刷新排行榜数据
  getrefresh( params ) {
    return new Promise((resolve, reject) => {
      $api.get($urls.DISCOUNTS.getrefresh, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          reject(resp)
        }
      },err=>{reject(err)})
    })
  },
  // 获取我的优惠列表
  myOffer(params = {}){
    // let params = {
    //   UUID: this.UUID,
    //   filterType: this.filterType,
    //   pageNo: this.pageNo,
    //   pageSize: this.pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.MYOFFER, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        } else {
          let obj = {
            list:[],
            total: 0,
          };
          resolve(obj)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 优惠详情
  offerDetail(params) {
   return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.offerDetail, params, (resp) => {
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 获取首页优惠图片
  getIndexOffer(params){
    return new Promise((resolve, reject) => {
      // let pageNo = 1;
      // let pageSize = 6;
      // let params = {
      //   frontType: 2,
      //   pageNo,
      //   pageSize
      // };
      $api.post($urls.HOMEBEFORE.INDEXOFFER,params,resp=>{
        if (resp.data.code === 200) {
          resolve(resp.data.data.list)
        } else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },
  // 获取优惠类型
  queryBonusArticleTypeList( params = {}) {
    return new Promise((resolve, reject) => {
       $api.post($urls.DISCOUNTS.queryBonusArticleTypeList, params, (resp) => {
         if(resp.data.code===200){
           let data = resp.data.data;
           resolve(data)
         }else {
           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
           reject(msg)
         }
       }, (err) => {reject(err.message)})
 
     })
   },
   //获取优惠列表（新）
   queryBonusArticleInfoList(params) {
    return new Promise((resolve, reject) => {
       $api.post($urls.DISCOUNTS.queryBonusArticleInfoList, params, (resp) => {
         if(resp.data.code===200){
           let data = resp.data.data;
           resolve(data)
         }else {
           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
           reject(msg)
         }
       }, (err) => {reject(err.message)})
 
     })
   },
    //活动大厅列表
    querySelfApplyBonusList(params) {
      return new Promise((resolve, reject) => {
         $api.post($urls.DISCOUNTS.querySelfApplyBonusList, params, (resp) => {
           if(resp.data.code===200){
             let data = resp.data.data;
             resolve(data)
           }else {
             let msg = resp.data.msg ? resp.data.msg :resp.data.message;
             reject(msg)
           }
         }, (err) => {reject(err.message)})
   
       })
     },
      //活动大厅获取文章
  queryBonusArticleInfoDetail(params) {
    return new Promise((resolve, reject) => {
       $api.post($urls.DISCOUNTS.queryBonusArticleInfoDetail, params, (resp) => {
         if(resp.data.code===200){
           let data = resp.data.data;
           resolve(data)
         }else {
           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
           reject(msg)
         }
       }, (err) => {reject(err.message)})
 
     })
   },
}

const DEPOSIT ={
  // 申请存款红利
  applyBonus(params) {
    // let params = {
    //   platformKey: this.platformKey,
    //   viewOfferId: this.viewOfferId,
    //   applyAmount: this.applyAmount,
    //   betOrderNo: this.betOrderNo
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.applyBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  // 申请VIP红利
  vipapplyBonus(params) {
    // let params = {
    //   platformKey: this.platformKey,
    //   viewOfferId: this.viewOfferId,
    //   applyAmount: this.applyAmount,
    //   betOrderNo: this.betOrderNo
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.vipapplyBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  // 申请时时优惠
  applyRealTimeAmount(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getRealTimeAmount, params, (resp) => {
        resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  // 申请投注优惠
  applyBetBonus(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.applyBetBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  // 申请时时优惠  手动审核
  applyUserAgentBonus(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getuserAgentBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  // 申请客制活动
  applyPrivateCustomBonus(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.applyPrivateCustomBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  // 查看可领取的时时流水优惠列表
  realTimeAmount(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.realTimeAmount, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 查询会员绑定优惠
  queryBonusBindUserInfoList(params) {
    // let params = {
    //   UUID: this.UUID
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.queryBonusBindUserInfoList, params, (resp) => {
        resolve(resp)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 升级查询
  selectUserUpgradeInfo (params) {
    // let params = {
    //   UUID,
    //   viewOfferId
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.selectUserUpgradeInfo, params, (resp) => {
        if(resp.data.code == 200){
          resolve(resp.data.data)
        }else{
          reject(resp.data.msg)
        }
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 大转盘抽奖 未登录
  queryTurntableRaffle() {
    let params = {
      activityType: 1
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.queryTurntableRaffle, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },
// 大转盘抽奖 已登录
  raffle() {
    let params = {
      activityType: 1
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.raffle, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },

 // 小游戏最新中奖记录查询
 queryNewWin(params) {
  return new Promise((resolve, reject) => {
    $api.post($urls.DEPOSIT.queryNewWin, params, (resp) => {
      resolve(resp.data)
    }, (err) => {
      reject(err.message)
    })
  })
},
// 历史中奖数据
  queryHistoryWin(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.queryHistoryWin, params, (resp) => {
        let data = resp.data.data;
        if(data===null) {
          let obj={
            list: [],
            pageInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            }
          };
          resolve(obj)
        }

        let list = data.list;
        let obj={
          list: list,
          pageInfo: data
        };
        resolve(obj)
      }, (err) => {
        reject(err.message)
      })
    })
  },

  // 领取红利
  receiveMyBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.receiveMyBonus, params, (resp) => {
          resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  // ============余额宝==========================
  // 查询可购买的余额宝列表
  checkAvailableYEBListHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.availableYEBList, params, (resp) => {
        resolve(resp)
      }, (err) => { reject(err.message) })
    })
  },
  // 查询已购买的余额宝列表
  checkPurchasedYEBListHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.purchasedYEBList, params, (resp) => {
        resolve(resp)
      }, (err) => { reject(err.message) })
    })
  },
  // 购买余额宝
  buyYEBProgramHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.buyYEBProgram, params, (resp) => {
        resolve(resp)
      }, (err) => { reject(err.message) })
    })
  },
  // 赎回余额宝
  ransomYEBProgramHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.ransomYEBProgram, params, (resp) => {
        resolve(resp)
      }, (err) => { reject(err.message) })
    })
  },
  
  // ============红绿灯彩票==========================
  // 获取红绿灯彩票信息初始化
  LotteryInit(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.LotteryInit, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // 红绿灯彩票多条下注
  batchBettingGt(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.batchBettingGt, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // 获取红绿灯彩票的开奖记录
  getDrawLotteryList(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getDrawLotteryList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // 获取红绿灯彩票的投注记录
  getUserDrawLotteryList(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getUserDrawLotteryList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },



  // ================================================
  // VIP页面领取接口  1晋升礼金2生日礼金3节日礼金
  getVipRewardGift(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getVipRewardGift, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // VIP快速晋级申请
  fastApplyPromotion(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.fastApplyPromotion, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // 获取所有可领取的时时流水金额
  realTimeAmountAll(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.realTimeAmountAll, params, (resp) => {
        if(resp.data.code===200){
          let data = resp.data.data
          resolve(data)
        }else{
          let data = resp.data.msg
          reject(data)
        }
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 领取所有可领取的时时流水金额
  getRealTimeAmountAll(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getRealTimeAmountAll, params, (resp) => {
        if(resp.data.code===200){
          let data = resp.data.msg
          resolve(data)
        }else{
          let data = resp.data.msg
          reject(data)
        }
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 获取流水优惠记录
  realTimeRecord(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.realTimeRecord, params, (resp) => {
        if(resp.data.code===200){
          let data = resp.data.data
          resolve(data)
        }else{
          let data = resp.data.msg
          reject(data)
        }
      }, (err) => {
        reject(err.message)
      })
    })
  },
};

const SPORT = {
  // 申请存款红利
  sport(sportId, market) {
    let params = {
      sportId: sportId,
      market: market
    }
    return new Promise((resolve, reject) => {
      $api.post($urls.SPORT.sport, params, (resp) => {
        resolve(resp.data)
      }, (err) => {reject(err.message)})
    })
  }
}

const Cicket ={
  getTaskList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.Cicket.getTaskList, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  getTaskPrize(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.Cicket.getTaskPrize, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  getHeadTaskList(params={}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.Cicket.getHeadTaskList, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  getMyBets(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.Cicket.getMyBets, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
}

const team ={
  queryBelongTotalInfo(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.team.queryBelongTotalInfo, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  queryTeamTotalInfo(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.team.queryTeamTotalInfo, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  queryTeamList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.team.queryTeamList, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  queryBelongList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.team.queryBelongList, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  queryMyTeamInfo(params={}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.team.queryMyTeamInfo, params, (resp) => {
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })
    })
  },
}

const commonApi= {
  Cicket,
  team,
  HOMEBEFORE,
  HOMEAFTER,
  DISCOUNTS,
  USER,
  SLOT,
  WALLET,
  VIP,
  PAY,
  HELP,
  CONFIRM,
  GAME,
  DEPOSIT,
  SPORT,
  SIGN,
};
export default commonApi



// WEBPACK FOOTER //
// ./src/common/utils/commonApi.js